<template>
  <div :id="id" class="container-select" :style="styledFocusSelect(filterActive, 'border')">
    <div class="container-button white-space-now-wrap d-flex align-item-center gap-2" @click="toggleSelect">
      <span :style="styledFocusSelect(filterActive, 'color')"><b>{{ label }}: </b></span>
      <span v-if="!selectedItem.id || !selectedItem.name" class="option-selecione" :style="styledFocusSelect(filterActive, 'color')">Selecione</span>
      <span :style="styledFocusSelect(filterActive, 'color')">{{ selectedItem.name }}</span>
      <SVGIcon v-if="!standalone" iconName="icon-close" :size="8" @click.stop="onExcluded" />
    </div>
    <div class="select-filtro" v-if="filterActive">
      <div class="container-search">
        <i class="fa fa-search icn-search"></i>
        <input
          type="text"
          class="ipt-search"
          :placeholder="searchPlaceholder"
          v-model="search"
        />
      </div>
      <div class="container-items">
        <div 
          class="item"
          @click="selectItem({ id: '', name: '' })"
        >
          Selecione
        </div>
        <div
          v-for="(item, index) in filteredItems"
          :key="index"
          class="item"
          :class="{ 'selected': selectedItem.id === item.id }"
          @click="selectItem(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SVGIcon from '../../SvgIcon.vue';
import { removeAccents } from '../helpers';
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: "Item",
    },
    searchPlaceholder: {
      type: String,
      default: "Busque pelo campo",
    },
    filtro_id: {
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: false,
      default: ''
    },
    standalone: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SVGIcon,
  },
  data() {
    return {
      search: "",
      filterActive: false,
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => {
        if (!item?.name && item?.name !== 0) return false;
        const name = removeAccents(String(item.name).toLowerCase());
        const search = removeAccents(this.search.toLowerCase());
        return name.includes(search);
      });
    },
  },
  methods: {
    toggleSelect() {
      this.filterActive = !this.filterActive;
    },
    selectItem(item) {
      if (!item) {
        console.warn('Item inválido selecionado');
        return;
      }
      const resultItem = item.id === this.selectedItem.id ? {
        id: "",
        name: "",
      } : item;

      this.$emit("atualizar", resultItem);
      this.filterActive = false;
    },
    onExcluded() {
      if (this.standalone) {
        this.$emit('atualizar', { id: '', name: '' });
        return;
      }
      this.$store.commit('removeFiltro', this.filtro_id);
      this.$removeFiltroDaURL(this.filtro_id, this.path);
      this.$filtroDb.removeFiltro(this.path, this.filtro_id)
        .catch(error => exibe_erro('Erro ao remover preferencia de filtro'));
    },
    styledFocusSelect(filterActive, style) {
      if(!filterActive) return;

      if (style === 'color')
        return 'color: var(--maino-blue-hover)';
      else if (style === 'border')
        return 'border-color: var(--maino-blue-hover)';
    }
  },
  mounted() {
    document.addEventListener('click', (event) => {
      if (event.target.closest(`#${this.id}`) === null && this.filterActive) {
        this.filterActive = false;
      }
    });
  },
};
</script>
